<template>
  <div :id="content.idHTML" class="px-0 py-0">
    <ValidationObserver ref="observer" v-slot="{ invalid }" :vid="'vobserver' + uniqueId" tag="div">
      <b-form :id="'idFormulaire' + uniqueId" @submit.stop.prevent="onSubmit($event)">
        <!-- Title  -->
        <Titre
          :content="{
            titre: title,
            type: 'titre pt-0 pb-1',
          }"
          :class="['title-secondary', { 'title-option': category !== 'deposit' }]"
        ></Titre>
        <!-- Description -->
        <Paragraphe
          :content="{
            richText: texte,
            classeCSS: 'pb-1',
          }"
          class="texte-desc"
        ></Paragraphe>
        <Hyperlien v-if="contentAide" :content="contentAide" class="mt-n1 mb-2 fs-1" />
        <!-- If submit chosen limit is success -->
        <div v-if="!isSuccess" class="input-btn-group">
          <GroupeRadioDepot
            v-model="choix"
            :cat="category"
            :content="contentGroupeRadio"
            @input="setLimitValue"
          ></GroupeRadioDepot>
          <!-- Message erreur d'envoi -->
          <div v-show="isErreurServeur" class="error-depot">
            <MessageMel
              v-show="contentMessageMel.message"
              :content="contentMessageMel.message"
              class="mt-n1 mt-md-0 mx-0 pl-0 d-flex justify-content-end"
            ></MessageMel>
          </div>
          <!-- Bouton Confirmer -->
          <div v-show="showConfirmBtn" class="btn-right">
            <button
              type="submit"
              class="btn btn-confirm px-6 mb-0"
              tabindex="0"
              :disabled="invalid || isSubmitted"
              @click="confirmChoice"
            >
              <div class="load-spinner">
                <div v-if="isSubmitted" class="mr-1">
                  <b-spinner small :label="$t('chargement')"></b-spinner>
                </div>
                <span class="btn-text">{{ content.libBtnConfirmer }}</span>
              </div>
            </button>
          </div>
        </div>
        <!-- Show actual limit chosen -->
        <div v-show="isSuccess" class="actual-limit">
          <span>{{ getTextLocalised(choix) }}</span>
        </div>
      </b-form>
    </ValidationObserver>
  </div>
</template>

<script>
// LQ
import VMoney from 'v-money';
import GroupeRadioDepot from '@/components/formulaire/base/GroupeRadioDepot';
import Hyperlien from '@/components/base/Hyperlien';
import MessageHelpers from '@/helpers/MessageHelpers';
import MessageMel from '@/components/base/MessageMel';
import encadrerJeux from '@/services/api/compte/encadrerJeux';
import Paragraphe from '@/components/base/Paragraphe';
import Titre from '@/components/base/Titre';
import { formatMontant } from '@/helpers/StringHelpers';
import { inMgnl } from '@/helpers/AppHelpers';
import { bus } from '@/main';

export default {
  name: 'LimiteDepotChoix',

  components: {
    GroupeRadioDepot,
    Hyperlien,
    MessageMel,
    Paragraphe,
    Titre,
  },
  directives: { money: VMoney },
  props: {
    category: String,
    period: String,
    initialValue: { type: Object, default: null },
    content: { type: Object, required: true },
    title: String,
    texte: String,
  },
  i18n: {
    messages: {
      fr: {
        messageComponent: {
          day: 'quotidienne',
          week: 'hebdomadaire',
          month: 'mensuel',
        },
      },
      en: {
        messageComponent: {
          day: 'daily',
          week: 'weekly',
          month: 'monthly',
        },
      },
    },
  },
  data() {
    return {
      choix: this.initialValue || null,
      otherValue: null,
      isSubmitted: false,
      showConfirmBtn: false,
      isAlerteExist: false,
      isErreurServeur: false,
      isSuccess: false,
      uniqueId: this.uid,
      isConfirmed: false,
      contentMessageMel: {
        message: {},
      },
      minMax: {
        maxTimeDay: 1 * 24,
        maxTimeWeek: 7 * 24,
        maxTimeMonth: 31 * 24,
        maxLoss: 999999,
      },
    };
  },
  computed: {
    contentAide() {
      return {
        texte:
          this.content[
            `libAideLimite${this.category.charAt(0).toUpperCase() + this.category.slice(1)}`
          ],
        type: 'aide',
        lien: {
          idAide:
            this.content[
              `idQuestionLimite${this.category.charAt(0).toUpperCase() + this.category.slice(1)}`
            ],
        },
      };
    },
    labelPeriod() {
      return this.period.charAt(0).toUpperCase() + this.period.slice(1);
    },
    getContentTxtDelais() {
      return this.content[`txtDelais${this.labelPeriod}`];
    },
    unite() {
      return this.category === 'time' ? 'h' : '$';
    },
    getInputLength() {
      const lengthMap = { time: 3, loss: 7 };
      return lengthMap[this.category] || 4;
    },
    // Construction des valeurs d'encrage pour les limites
    getOptionsLimit() {
      const idx = 0;
      // let idx = 0;
      // if (this.category == 'deposit') {
      //   // cas d'exception
      //   idx = 0;
      // } else if (this.period === 'week') {
      //   idx = 1;
      // } else if (this.period === 'month') {
      //   idx = 2;
      // }

      const nodeKey = this.content[this.category]['@nodes'][idx];
      const nodeData = this.content[this.category][nodeKey];

      const unArray = [];
      unArray.push(
        { text: this.getTextLocalised(nodeData.limit1), value: nodeData.limit1 }, // `${nodeData.limit1} ${this.unite}`
        { text: this.getTextLocalised(nodeData.limit2), value: nodeData.limit2 }
      );
      // cas d’exception
      const casException = this.category === 'time' && this.period === 'day';
      if (!casException) {
        unArray.push({ text: this.getTextLocalised(nodeData.limit3), value: nodeData.limit3 });
      }
      unArray.push({ text: this.content.libAutreLimite, value: 0 });
      return unArray;
    },

    // Affichage info sous input GroupRadio
    getMinMaxValueValidationAutre() {
      let min = process.env.VUE_APP_MIN_LIMITE_DEPOT_HEBDO;
      let max = process.env.VUE_APP_MAX_LIMITE_DEPOT_HEBDO;
      let validationMsg = '';

      if (this.category === 'deposit') {
        validationMsg = this.$i18n.t('validations.messages.encadrerJeux.limiteDepotInvalide', {
          min: formatMontant(min),
          max: formatMontant(max),
        });
      } else if (this.category === 'time') {
        min = 1;
        if (this.period === 'day') {
          max = this.minMax.maxTimeDay;
        } else if (this.period === 'week') {
          max = this.minMax.maxTimeWeek;
        } else if (this.period === 'month') {
          max = this.minMax.maxTimeMonth;
        }
      } else {
        min = 1;
        max = this.minMax.maxLoss;
      }
      return { min, max, validationMsg };
    },

    contentGroupeRadio() {
      return {
        format: 'tableau',
        optionsInfo: this.getOptionsLimit,
        type: 'number',
        minMaxValues: this.getMinMaxValueValidationAutre,
        validationAutre:
          this.category === 'time'
            ? `is_limite_temps_bienJouer_valid:${this.getMinMaxValueValidationAutre.max}`
            : `is_limite_depot_bienJouer_valid:${this.getMinMaxValueValidationAutre.min},${this.getMinMaxValueValidationAutre.max}`,
        libAutre: '',
        unite: this.category === 'time' ? 'h' : '$',
        inputLength: this.getInputLength,
      };
    },
  },

  methods: {
    confirmChoice() {
      // console.log(this.content, this.category, this.contentGroupeRadio.unite);
      this.isConfirmed = true;
      this.$emit('confirm-changed', this.isConfirmed);
    },
    onSubmit() {
      if (this.isSubmitted && !this.isConfirmed) {
        return;
      }
      this.isSubmitted = true;
      encadrerJeux
        .setLimiteJeux({ category: this.category, period: this.period, value: this.choix })
        .then((response) => {
          this.isSubmitted = false;
          // console.log('response : ', response);
          this.isErreurServeur = false;
          this.isSuccess = true;
          this.$emit('success-limitSet');
        })
        .catch((error) => {
          // TODO gestion erreur
          console.error('Erreur de récupération des données!', error);
          this.isSuccess = false;
          this.gererMessageErreur(error);
          this.isSubmitted = false;
        });
    },

    async affichageMessageErreur(code, type) {
      this.contentMessageMel[type] = await this.recupererMessage(code);
      this.isErreurServeur = true;
    },

    setLimitValue(value) {
      this.showConfirmBtn = true;
      this.choix = value;
      this.$emit('show-message', this.showConfirmBtn);
      // console.log(`input = ${this.choix}`);
      // console.log(`category = ${this.category}`);
      // console.log(`period = ${this.period}`);
    },

    getTextLocalised(value) {
      if (this.category === 'time') {
        return `${value} ${this.unite}`;
      }
      return formatMontant(value);
    },

    // TODO mettre cette fonction dans le helper
    recupererMessage(codeMessage, keysValueRemplacement = {}) {
      return new Promise((resolve, reject) => {
        MessageHelpers.obtenirMessage(codeMessage, this.$root)
          .then((msgResp) => {
            let messageTraiter = msgResp.msgDetail;
            if (keysValueRemplacement) {
              Object.entries(keysValueRemplacement).forEach(([cle, valeur]) => {
                const regex = new RegExp(`\\{{${cle}\\}}`, 'g');
                messageTraiter = messageTraiter.replace(regex, valeur);
              });
            }
            resolve({
              titre: msgResp.msgTitre,
              message: messageTraiter,
              msgType: msgResp.msgType,
            });
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    async gererMessageErreur(error) {
      const errorCause = error?.response?.data?.detailCause;
      // console.log(errorCause);
      if (['LIMIT_INCREASE_QUEUED', 'MAX_INCREASE_LIMIT'].includes(errorCause)) {
        this.affichageMessageErreur(`MSG05-6-09-${this.category}`, 'message'); // x 3
      } else if (errorCause === 'DAY_GREATER_WEEK') {
        this.affichageMessageErreur('MSG05-6-10', 'message');
      } else if (errorCause === 'WEEK_GREATER_MONTH') {
        this.affichageMessageErreur('MSG05-6-11', 'message');
      } else if (errorCause === 'DAY_GREATER_MONTH') {
        this.affichageMessageErreur('MSG05-6-12', 'message');
      } else {
        this.affichageMessageErreur('MSG05-6-03', 'message');
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.pannel-body {
  background-color: $couleur-bg-form-bien-jouer;
}

.btn-primaire-limite {
  display: flex !important;
  height: 3rem;
  padding: 0.5rem;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  align-self: stretch;
  border-radius: 2.5rem !important;
  background: $couleur-btn-bien-jouer;
  color: $couleur-noir !important;

  &.disabled,
  &:disabled {
    opacity: 50%;
    background: $couleur-btn-inactif-bien-jouer;
    border: 1px solid #192872;
    cursor: not-allowed;
  }

  &:not(.disabled):not(:disabled):active,
  &:not(.disabled):not(:disabled):focus,
  &:not(.disabled):not(:disabled):hover {
    background: $couleur-btn-hover-bien-jouer;
  }
}
.texte-legal {
  font-size: 14px;
}

// Nudge 3 ------------------------------------------------------------
.btn-right {
  display: flex;
  justify-content: flex-end;
  margin-top: 2rem;
  .btn-confirm {
    box-shadow: none;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
    border-radius: 32px;
    border: 1px solid #192872;
    font-weight: bold;
    font-family: 'graphik_semibold';
    color: #192872;
    &:focus,
    &:focus-visible {
      outline-offset: 5px;
      outline: 2px solid black;
    }
    @include media-breakpoint-down(xs) {
      width: 100%;
    }
    &.disabled,
    &:disabled {
      opacity: 50%;
      border: 1px solid #ccc;
      cursor: not-allowed;
    }
    &:not(.disabled):not(:disabled):active,
    &:not(.disabled):not(:disabled):focus,
    &:not(.disabled):not(:disabled):hover {
      background: #192872;
      color: white;
    }
  }
}

.btn-rigth {
  display: flex;
  justify-content: center;
  margin: 1rem 0 1rem;

  .btn {
    width: 100%; /* 100% de largeur sur mobile */
  }
}

.actual-limit {
  display: flex;
  justify-content: flex-end;
  span {
    font-family: 'graphik_semibold';
    font-size: 24px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }
}

.load-spinner {
  display: flex;
  justify-content: center;
}

.error-depot {
  display: flex;
  justify-content: flex-end;
  > div {
    display: flex !important;
    justify-content: flex-end !important;
    width: 75%;
    @include media-breakpoint-down(sm) {
      width: 100%;
    }
  }
}

::v-deep .aide {
  font-size: 12px;
}

.title-option {
  ::v-deep.titre {
    font-size: 18px !important;
  }
}

@media (min-width: 768px) {
  .btn-rigth {
    justify-content: flex-end; /* Aligné à droite */

    .btn {
      width: 50%; /* 100% de largeur sur mobile */
    }
  }
}
</style>